import { variableAndDigitSearch } from '../../../const';
import { DesignModuleNode } from '../../../types';

export type GetVariablesFromAllTextsProps = {
  isOmniChannel: boolean;
  node: DesignModuleNode;
  removeBraces?: boolean;
  unique?: boolean;
};

export function getVariablesFromAllTexts({
  isOmniChannel,
  node,
  removeBraces = true,
  unique = true
}: GetVariablesFromAllTextsProps): string[] {
  const { config } = node.props;

  const channelObjects = (isOmniChannel && config?.channel) ? (
    Object.values(config.channel)
  ) : [config.text!];

  if (!channelObjects?.length) {
    return [];
  }

  let vars = channelObjects.flatMap((channelObject) => {
    const localized = Object.values(channelObject);
    return localized.flatMap((text) => {
      const match = text.match(variableAndDigitSearch);
      return match ?? [];
    });
  });

  if (removeBraces) {
    vars = vars.map((variable) => variable.replace(/{{|}}/g, ''));
  }

  if (unique) {
    return [...new Set(vars)];
  }

  return vars;
}
